import { gromartServer } from "../config/appConfig";
import axios from "axios";

const uploadService = {
  uploadFile(fileData) {
    let body = new FormData();
    body.append("file", fileData)
    return axios({
      method: "post",
      url: gromartServer + "/api/file/upload",
      data: body,
      crossOrigin: true,
    });
  },
}

export default uploadService; 